var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "TextareaView u-InputMarginView",
      class: [
        _vm.modes.map((m) => `TextareaView--${m}`),
        { "TextareaView--error": _vm.isError && _vm.required },
      ],
    },
    [
      _vm.required
        ? _c("span", { staticClass: "TextareaViewRequired" }, [_vm._v("*")])
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c(
            "label",
            {
              staticClass: "TextareaViewLabel",
              attrs: { for: `TextareaView-input-${_vm._uid}` },
            },
            [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("textarea-autosize", {
        staticClass: "TextareaViewInput transparent",
        style: { height: _vm.height, width: _vm.width },
        attrs: {
          id: `TextareaView-input-${_vm._uid}`,
          placeholder: _vm.placeholder,
          disallowNewline: _vm.disallowNewline,
        },
        model: {
          value: _vm.formattedValue,
          callback: function ($$v) {
            _vm.formattedValue = $$v
          },
          expression: "formattedValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }